import { UHCSliderCompleteProps } from "../SliderAndVcpu";
import { GroupingVcpu, UHC_VcpuProps } from "./Vcpu";

export function convertPipesToGroupingVcpu (pipes: UHCSliderCompleteProps['pipes']):GroupingVcpu[] {
    return Object.values(pipes.reduce((c, v, i) => {
        c[v.vcpu] = c[v.vcpu] || [v.vcpu, 0];
        c[v.vcpu][1] = c[v.vcpu][1] + 4;
        if (i === 0 || i === pipes.length - 1) {
            c[v.vcpu][1] = c[v.vcpu][1] - 2;
        }
        return c;
    }, {})).map(
        (o) => {
            return {
                vcpu: o[0],
                blocos: o[1]
            }
        }
      );
}

export function getGroupVcpuSelected(currentPipe:UHC_VcpuProps['currentPipe'], pipes: UHCSliderCompleteProps['pipes']):GroupingVcpu['vcpu']{
    return pipes.filter((val, index)=>index == currentPipe)[0].vcpu
}